export default "__VITE_ASSET__S$WLtPp5__"